import { UserPlus, Share2, MoreVertical, Pencil, LogOut, ArrowLeft } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { formateazaRON } from "@/lib/settlement";

// Header-ul paginii de grup: înapoi, adaugă membru, invită, meniu (redenumire/părăsire).
export function GroupHeader({ group, total, onBack, onAddMember, onInvite, onRename, onLeaveClick }) {
  return (
    <header className="sticky top-0 z-20 backdrop-blur-lg bg-background/80 border-b border-slate-100 px-4 py-4">
      <div className="flex items-center justify-between">
        <button
          data-testid="back-btn"
          aria-label="Înapoi"
          onClick={onBack}
          className="h-10 w-10 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors"
        >
          <ArrowLeft className="h-5 w-5 text-slate-700" strokeWidth={2.5} />
        </button>
        <div className="flex items-center gap-2">
          <button
            data-testid="open-add-member-btn"
            onClick={onAddMember}
            className="h-10 px-3 flex items-center gap-1.5 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold transition-colors"
          >
            <UserPlus className="h-4 w-4" strokeWidth={2.5} />
            Membru
          </button>
          <button
            data-testid="invite-btn"
            onClick={onInvite}
            className="h-10 px-3 flex items-center gap-1.5 rounded-full bg-emerald-100 hover:bg-emerald-200 text-emerald-700 text-sm font-semibold transition-colors"
          >
            <Share2 className="h-4 w-4" strokeWidth={2.5} />
            Invită
          </button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="group-menu-btn"
                aria-label="Mai multe"
                className="h-10 w-10 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-600 transition-colors"
              >
                <MoreVertical className="h-5 w-5" strokeWidth={2.5} />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="rounded-xl">
              {group.isOwner && (
                <DropdownMenuItem
                  data-testid="rename-group-btn"
                  onClick={onRename}
                  className="cursor-pointer"
                >
                  <Pencil className="h-4 w-4 mr-2" />
                  Editează numele
                </DropdownMenuItem>
              )}
              {!group.isOwner && (
                <DropdownMenuItem
                  data-testid="leave-group-btn"
                  onClick={onLeaveClick}
                  className="cursor-pointer text-rose-600 focus:text-rose-600"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Părăsește grupul
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <div className="mt-3 px-1">
        <h1 className="font-heading text-2xl font-black text-slate-900">
          {group.name}
        </h1>
        <p className="text-sm text-slate-500 mt-0.5">
          Total: <span className="font-bold text-slate-700">{formateazaRON(total)}</span>
        </p>
      </div>
    </header>
  );
}
